import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { sanityCheckSourceUrl } from './admin_customization_helpers';
import { createRasterStyle } from './raster_helpers';
import { loadVectorStyle } from './style_helpers';

// Note: all non-raster styles have attributions embeded in sources/layers already
const styleConfigs = {
  alltrailsOutdoorsV2: {
    displayName: 'AllTrails',
    loadStyle: (locale, displayMetric) => loadVectorStyle('alltrails/ck6ihzq4v0e801ipws9d40r9m', locale, displayMetric),
    terrainEnabled: true,
    keyboardShortcut: 'F'
  },
  alltrailsSatellite: {
    displayName: StringConstantsMixin.strings.MAP_LAYER_NAMES.SATELLITE,
    loadStyle: (locale, displayMetric) => loadVectorStyle('alltrails/cjp90np3z44xz2rofjvdakfbh', locale, displayMetric),
    terrainEnabled: true,
    keyboardShortcut: 'S'
  },
  arcgisSatellite: {
    displayName: 'ArcGIS',
    aclVisible: ['admin', 'notMobile'],
    loadStyle: () =>
      Promise.resolve(
        createRasterStyle('arcgisSatellite', 'https://tiles-asatellite.alltrails.com/{z}/{y}/{x}.png', {
          attribution: 'Copyright © 2013 ESRI',
          tileSize: 256,
          maxzoom: 19
        })
      ),
    keyboardShortcut: 'A'
  },
  adminBasemap: {
    displayName: 'Custom basemap',
    aclVisible: ['admin', 'notMobile'],
    loadStyle: (locale, displayMetric, adminCustomizationSettings) => {
      if (!adminCustomizationSettings || !sanityCheckSourceUrl(adminCustomizationSettings.basemapSourceUrl)) {
        return Promise.reject();
      }
      return Promise.resolve(
        createRasterStyle('adminBasemap', adminCustomizationSettings.basemapSourceUrl, {
          tileSize: 256,
          maxzoom: 19
        })
      );
    },
    keyboardShortcut: 'B'
  },
  opencycle: {
    displayName: 'OCM',
    loadStyle: () =>
      Promise.resolve(
        createRasterStyle('opencycle', 'https://tiles-ocm.alltrails.com/{z}/{x}/{y}.png', {
          attribution: '© <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
          tileSize: 256,
          maxzoom: 19,
          minzoom: 4
        })
      ),
    keyboardShortcut: 'Q'
  },
  openstreet: {
    displayName: 'OSM',
    loadStyle: () =>
      Promise.resolve(
        createRasterStyle('openstreet', 'https://tiles-osm.alltrails.com/{z}/{x}/{y}.png', {
          attribution: '© <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
          tileSize: 256,
          maxzoom: 19,
          minzoom: 4
        })
      ),
    keyboardShortcut: 'E'
  },
  roadmap: {
    displayName: StringConstantsMixin.strings.MAP_LAYER_NAMES.ROAD,
    loadStyle: (locale, displayMetric) => loadVectorStyle('mapbox/streets-v10', locale, displayMetric),
    keyboardShortcut: 'R'
  },
  topo: {
    displayName: StringConstantsMixin.strings.MAP_LAYER_NAMES.USGS_TOPO_US_ONLY,
    loadStyle: () =>
      Promise.resolve(
        createRasterStyle('topo', 'https://us-topo.alltrails.com/{z}/{x}/{y}.png', {
          attribution: '© 2020 AllTrails',
          tileSize: 256,
          maxzoom: 16,
          minzoom: 4
        })
      ),
    keyboardShortcut: 'T'
  },
  worldparks: {
    displayName: StringConstantsMixin.strings.MAP_LAYER_NAMES.WORLD_PARKS,
    loadStyle: (locale, displayMetric) => loadVectorStyle('alltrails/cjpbskuvg2f622smu19gk59y7', locale, displayMetric),
    keyboardShortcut: 'W'
  },
  worldtopo: {
    displayName: StringConstantsMixin.strings.MAP_LAYER_NAMES.TERRAIN,
    loadStyle: () =>
      Promise.resolve(
        createRasterStyle('worldtopo', 'https://tiles-wtopo.alltrails.com/{z}/{y}/{x}.png', {
          attribution: 'Copyright © 2013 ESRI',
          tileSize: 256,
          maxzoom: 19
        })
      ),
    keyboardShortcut: 'D'
  }
};

export { styleConfigs };
